import Repository from "./Repository";

export default {
  postIssue: (data) =>
    Repository.post("/issues/", data, {
      timeout: 60000,
    }),
  getCategories: () => Repository.get("/issues/categories/"),
};
